
<button :id="id" class="c-button -simple-green -sp-full" :type="type" :action="action" @click="clickAction">
  <slot />
</button>
